import api from '@/api';
import ErrorMixin from '@/components/Notifications/ErrorMixin';

/**
 * Requires the consuming component to provide:
 *   - clientActionId {Number} — the ID used to build the audit-trail endpoint
 */
export default {
  mixins: [ErrorMixin],
  data() {
    return {
      loading: false,
    };
  },
  methods: {
    async exportAuditTrail() {
      this.loading = true;

      try {
        await api.post(`v1/actions/${this.clientActionId}/audit-trail/email`);

        this.$notify({
          duration: 7000,
          title: 'Success!',
          text: 'Your export will be emailed to you shortly.',
          type: 'success',
        });
      } catch (e) {
        this.showErrorMessage(e);
      } finally {
        this.loading = false;
      }
    },
  },
};
